// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 14.1172L19.1816 18L16 14.7646L12.8184 18L9 14.1172L16 7L23 14.1172Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.833 9.5L4.5 16.833L1 13.333L8.33301 6L11.833 9.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-tencentmeeting-filled')
export default class LogoTencentmeetingFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-tencentmeeting-filled',
    }
  }
}
